import React, { useState } from 'react';
import {
  CustomModal,
  getTranslatedText,
  SaveCard,
  Loader,
  toast,
  useActivityTracker,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import {
  GET_EXPORT_REPORT_CONFIG,
  GET_EXPORT_REPORT_CONFIG_META,
  UPDATE_REPORT_EXPORT_CONFIG
} from '@nile/reports/src/modules/reports/graphql';
import envConfig from '@nile/home/src/Config/env';
import {
  PDF_META_MAP as getPDFMetaMap,
  CHOICES_LABEL
} from '@nile/reports/src/modules/reports/constants';
import { AccountClient } from '@nile/graphql';
import {
  DisplayText,
  Page,
  RadioButton,
  TextStyle
} from '@superops/ui-design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';

function PDFConfigurationModal(props) {
  const { callBack } = props;
  const intl = useIntl();
  const isITProduct = useProduct(COMMON_CONSTANTS.IT);

  const PDF_META_MAP = getPDFMetaMap(isITProduct);

  const [configData, setConfigData] = useState({
    reportType: 'PDF',
    pdfReportConfig: {
      clientLogo: false,
      autoGeneratedText: false
    }
  });
  const [isLoading, setIsLoading] = useState(false);

  const { data: metaData, loading: metaLoading } = useQuery(
    GET_EXPORT_REPORT_CONFIG_META,
    {
      client: AccountClient
    }
  );

  const { loading: dataLoading } = useQuery(GET_EXPORT_REPORT_CONFIG, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      input: {
        reportType: 'PDF'
      }
    },
    onCompleted(res) {
      setConfigData(res?.getReportExportConfig);
    }
  });

  const handleOptionChange = (data, option) => {
    setConfigData((prevState) => ({
      ...prevState,
      pdfReportConfig: {
        ...prevState?.pdfReportConfig,
        [data?.key]: option?.value
      }
    }));
  };

  const handleSave = () => {
    setIsLoading(true);
    AccountClient.mutate({
      mutation: UPDATE_REPORT_EXPORT_CONFIG,
      variables: { input: configData }
    }).then((res) => {
      if (res?.data?.updateReportExportConfig) {
        toast('success', 'report.pdf.config.updated.success');
        useActivityTracker({
          event: 'PDF Global configuraion change',
          data: { ...configData?.pdfReportConfig }
        });
        setIsLoading(false);
        if (callBack) {
          callBack();
        }
      }
    });
  };

  return (
    <CustomModal open locked onClose={callBack}>
      <Page
        variant="primary"
        title={getTranslatedText(intl, 'reports.pdf.configuration.title')}
        primaryAction={
          <SaveCard
            removeSecondaryBtnBg
            handleSave={handleSave}
            actions={{ back: callBack }}
            loading={isLoading}
          />
        }
      >
        <div className="vh-set-banner w900">
          {metaLoading || dataLoading ? (
            <Loader />
          ) : (
            <>
              {metaData?.getReportExportConfigMeta?.pdfReportConfig?.map(
                (el) => (
                  <div className="mb20">
                    <div className="mb10">
                      <DisplayText element="h3" weight="Bold">
                        <FormattedMessage id={PDF_META_MAP[el?.key]?.title} />
                      </DisplayText>
                    </div>
                    <div className="fx">
                      <div className="f11">
                        <div className="mb10">
                          <TextStyle variation="subdued">
                            <FormattedMessage
                              id={PDF_META_MAP[el?.key]?.description}
                            />
                          </TextStyle>
                        </div>
                        {el?.options?.map((opt) => (
                          <div className="mb6">
                            <RadioButton
                              label={getTranslatedText(
                                intl,
                                CHOICES_LABEL[opt?.key]
                              )}
                              onChange={() => handleOptionChange(el, opt)}
                              checked={
                                configData?.pdfReportConfig?.[el?.key] ===
                                opt?.value
                              }
                              key={`${el?.key}_${opt?.key}`}
                            />
                          </div>
                        ))}
                      </div>
                      <div className="f11 ml-40">
                        <div className="mb10">
                          <TextStyle variation="subdued">
                            <FormattedMessage
                              id={PDF_META_MAP[el?.key]?.imageHeader}
                            />
                          </TextStyle>
                        </div>
                        <img
                          src={`${envConfig.imageRoot}svg/${
                            PDF_META_MAP[el?.key]?.logo
                          }.svg`}
                          alt={el?.key}
                        />
                      </div>
                    </div>
                  </div>
                )
              )}
            </>
          )}
        </div>
      </Page>
    </CustomModal>
  );
}

export default PDFConfigurationModal;
